import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';

const JuntsGridNewsVariantItem = ({ item }) => {
  let href = item['@id'] || '';

  function getLink() {
    if (isInternalURL(href)) {
      return flattenToAppURL(href);
    } else if (href) {
      return href;
    }
  }

  return (
    <UniversalLink href={getLink()} className="junts-grid-news-item item">
      <div className="junts-grid-news-item-image">
        <img
          src={`${flattenToAppURL(item['@id'])}/@@images/${
            item.image_field
          }/large`}
          alt={item.title}
        />
      </div>
      <div className="junts-grid-news-item-date">
        {new Intl.DateTimeFormat('ca-ES').format(new Date(item.effective))}
      </div>
      <div className="junts-grid-news-item-title">{item.title}</div>
    </UniversalLink>
  );
};

export const JuntsGridNewsVariant = ({ items }) => {
  return (
    <section className="junts-grid-news-variant">
      {items.map((item) => (
        <JuntsGridNewsVariantItem key={item['@id']} item={item} />
      ))}
    </section>
  );
};
